import { Avatar, Icon } from '../../../../../components/UI'

import { getUserName } from '../../../../../helpers'

const ProfilePublicViewReview = ({ review }) => {
  return (
    <div className="rounded-[10px] border-[#FFCA84] border-[1px] p-[20px] w-full flex items-start flex-col">
      <div className="flex items-center">
        <div className="px-[4px] h-[32px] bg-white rounded-[2px] border-[#FEEBDD] border-[1px] flex items-center justify-center">
          <Icon name="star" color="#F79009" className="w-[20px] h-[20px]" />

          <span className="ml-[2px] inline-block text-base text-primary-100 font-bold">
            {review.rate}
          </span>
        </div>

        <span className="text-sm text-[#F79009] font-normal ml-[8px]">{review.date}</span>
      </div>

      <p className="text-base font-normal text-primary-100 mt-[8px]">{review.message}</p>

      <div className="mt-[8px] flex items-center w-full">
        <Avatar src={review.user.picture} className="w-[48px] h-[48px]" />

        <span className="ml-[8px] inline-block text-base text-primary-100 font-bold max-w-[80%] break-words">
          {getUserName(review.user)}
        </span>
      </div>
    </div>
  )
}

export default ProfilePublicViewReview
